<template>
  <KvTooltip v-if="address" :text="t('clients-timeline-sent_to_another_contact_help')" placement="top">
    <KvChip color="warning" rounded="soft" density="extra-compact" :prepend-icon="icon">
      {{ t('clients-timeline-sent_to_another_contact') }}
      <!-- i18n-validator-ignore-next-line: runtime recipient address -->
      <strong>{{ formattedAddress }}</strong>
    </KvChip>
  </KvTooltip>
</template>

<script>
import KvChip from '@/components/ui/kv-chip.vue';
import KvTooltip from '@/components/ui/kv-tooltip.vue';
import phoneMixin from '@/mixins/phone-mixin';

const PHONE_METHODS = ['sms', 'whatsapp', 'whatsapp-cloud', 'rcs'];

export default {
  name: 'NotificationRecipientChip',
  components: { KvChip, KvTooltip },
  mixins: [phoneMixin],
  props: {
    // Only set when the notification went somewhere other than the client's
    // own contact, so the chip renders itself only in that case.
    address: { type: String, default: null },
    method: { type: String, default: null },
  },
  computed: {
    isPhone() {
      return PHONE_METHODS.includes(this.method);
    },
    icon() {
      return this.isPhone ? 'ui-phone-call-01' : 'ui-mail-01';
    },
    formattedAddress() {
      if (!this.address) return '';
      return this.isPhone ? this.formatPhone(this.address) : this.address;
    },
  },
  methods: {
    t(term, replaces) {
      return this.$root.t(term, replaces);
    },
  },
};
</script>
